import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  /*  top menu */
  topmenuItem: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    cursor: "pointer",
    position: "relative",
    "& .userOptions": {
      "& .MuiSelect-select.MuiInputBase-input.MuiInput-input.MuiSelect-select":
        {
          [theme.breakpoints.down(1231)]: {
            paddingRight: 0,
            color: "transparent",
            minWidth: 0,
            width: "16px",
          },
        },
    },
    "&:has(.MuiSelect-iconOpen) svg path": {
      fill: theme.palette.mainButton.blue,
    },
    /* hover */
    "&:hover": {
      "& svg path": {
        fill: theme.palette.mainButton.blue,
      },
      "& .topmenuItemBtn, .MuiInputBase-root, .MuiSelect-iconOpen": {
        color: theme.palette.mainButton.blue,
      },
    },
    /* click */
    "&:active": {
      "& svg path": {
        // что-то переопределяет цвет  !!!
        fill: `${theme.palette.mainButton.darkBlue}!important`,
      },
      "& .topmenuItemBtn, .MuiInputBase-root, .MuiSelect-iconOpen": {
        // что-то переопределяет цвет  !!!
        color: `${theme.palette.mainButton.darkBlue}!important`,
      },
      "&:has(.MuiSelect-iconOpen)": {
        "& svg path": {
          fill: theme.palette.mainButton.darkBlue,
        },
      },
    },

        /* activeClass */
        '&.active': {
            '& svg path': {
                fill: theme.palette.mainButton.blue,
            },
            '& .MuiInputBase-root': {
                color: theme.palette.mainButton.blue
            },
            '& .MuiSelect-select::after': {
                left: 0,
                bottom: 8,
                right: 28,
                content: '""',  // !!! обязательно указать снаружи одинарные кавычки !!!
                position: "absolute",
                borderBottom: `2px solid ${theme.palette.mainButton.blue}`
            },
            '& .MuiInputBase-root::after': {
                border: "none"
            },
            '& .topmenuItemBtn': {
                color: theme.palette.mainButton.dark,
                fontFamily: "Roboto, sans-serif",
                /*fontSize: 14,*/
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "normal",
                position: "relative",
                '&.active': {
                    color: theme.palette.mainButton.blue
                }
            }
        },

        '@media (max-width: 1000px)': {
            '& .topmenuItemBtn': {
                fontSize: 12,
            }
        }

    },
    iconWrapper: {
        width: 16,
        height: 16,
        transform: "translateY(-1px)",
        '& svg': {
            width: "100%",
            height: "100%",
            maxWidth: "100%"
        }
    },
}));

export default useStyles;
